<canvas
    baseChart
    [data]="polarAreaChartData"
    [legend]="polarAreaLegend"
    [type]="polarAreaChartType"
>
</canvas>